module.exports = __webpack_public_path__ + "media/src/images/buttons/create_gift-2462a3f3d7576d899bd2a1f222910a67.svg";